import { useGateValue } from '@statsig/react-bindings';
import {
  PaymentGatewayType,
  PaymentType,
} from 'components/payment/payment.constants';
import { NewPaymentContext } from 'components/payment/payment.context';
import { usePaymentGatewayMatches } from 'components/payment/payment.new.hooks';
import { useContext } from 'react';

export const useIsNewSpreedlyCardFlow = () => {
  const { type } = useContext(NewPaymentContext);
  const isSpreedlySaveCard = useGateValue('spreedly-save-card');
  const paymentGatewayMatches = usePaymentGatewayMatches();

  return (
    paymentGatewayMatches([PaymentGatewayType.SPREEDLY]) &&
    isSpreedlySaveCard &&
    type === PaymentType.ORDER
  );
};
